import { Component, OnInit } from '@angular/core';

// The login check is the loggedIn guard in routes.ts: here it ran after the child pages were already built
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
